import React from 'react';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { Grid, Box, Typography, Modal, Input, InputAdornment, Tooltip } from '@material-ui/core';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import $ from "jquery"

var selectFirstOnEnter = function (input) {  // store the original event binding function
    var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;
    function addEventListenerWrapper(type, listener) {  // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected, and then trigger the original listener.
        if (type == "keydown") {
            var orig_listener = listener;
            listener = function (event) {
                var suggestion_selected = $(".pac-item-selected").length > 0;
                if (event.which == 13 && !suggestion_selected) {
                    var simulated_downarrow = $.Event("keydown", { keyCode: 40, which: 40 });
                    orig_listener.apply(input, [simulated_downarrow]);
                }
                orig_listener.apply(input, [event]);
            };
        }
        _addEventListener.apply(input, [type, listener]); // add the modified listener
    }
    if (input.addEventListener) {
        input.addEventListener = addEventListenerWrapper;
    } else if (input.attachEvent) {
        input.attachEvent = addEventListenerWrapper;
    }
}

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            googleapikey: '',
            base_url: '',
            date: new Date(),
            activeImgIdx: 0,
            selectedLat: 0,
            selectedLon: 0,
            selectedAddress: '',
            useCurLocation: false,
            curLocationLat: 0,
            curLocationLon: 0,
            searchTerm: "",
            open: false,
            openValidation: false,
            validationMessage: ''
        };

        this.autocomplete = null
        this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
        this.getClinics = this.getClinics.bind(this);
        this.currentLocation = this.currentLocation.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseValidation = this.handleCloseValidation.bind(this);
        this.handleFilterChanged = this.handleFilterChanged.bind(this);
        this.handleLocTextManualChange = this.handleLocTextManualChange.bind(this);
        this.inputInterval = null;
    }

    handlePlaceSelect() {
        this.props.ga_event('Landing Page', 'New Address Selected');

        let place = this.autocomplete.getPlace()
        let address = place.formatted_address;
        let lat = place.geometry.location.lat();
        let lon = place.geometry.location.lng();

        this.setState({
            useCurLocation: false,
            selectedLat: lat,
            selectedLon: lon,
            selectedAddress: address
        });
    }

    handleOpen() {
        this.props.ga_event('Landing Page','Learn More Link Clicked');

        this.setState({
            open: true,
        })
    }

    handleClose() {
        this.props.ga_event('Landing Page', 'Learn More Popup Closed');

        this.setState({
            open: false,
        })
    }

    handleCloseValidation() {
        this.setState({
            openValidation: false,
        })
    }

    _handleKeyDown = (event) => {
        switch (event.keyCode) {
            case 13: // enter key
                if ($("#autocomplete").is(":focus")) {
                    $("#autocomplete").blur();
                    return false;
                }
                this.props.ga_event('Landing Page', 'Enter Key Pressed - Search Applied');

                this.getClinics();
                break;
            default:
                break;
        }
    }

    componentDidMount() {
        selectFirstOnEnter(document.getElementById('autocomplete'));

        this.autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
            types: ['geocode']
        })
        this.autocomplete.addListener("place_changed", this.handlePlaceSelect)
        let base_url = this.props.base_url;
        let googleapikey = this.props.googleapikey;

        document.addEventListener("keydown", this._handleKeyDown);
        this.setState({
            base_url: base_url,
            googleapikey: googleapikey,
            activeImgIdx: Math.floor(Math.random() * 9) + 1
        });

        this.props.ga_pageview(window.location.pathname);

        this.resize();
        window.addEventListener('resize', this.resize)
    }

    resize() {
        // fixes an issue on mobile browser where the mobile keyboard resizes the browser viewport - forceing the background image to resize.
        $(function () {
            let viewheight = Math.floor($(window).height());
            let viewwidth = Math.floor($(window).width());
            let viewport = document.querySelector("meta[name=viewport]");
            viewport.setAttribute("content", "height=" + viewheight + "px, width=" + viewwidth + "px, initial-scale=1.0");
        });
    }

    componentWillUnmount() {
        if (this.inputInterval) {
            clearInterval(this.inputInterval);
        }
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    handleFilterChanged(event) {
        this.props.ga_event('Landing Page', 'Keyword Filter Changed');

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (target.type === 'text') {
            clearTimeout(this.inputInterval);
            this.inputInterval = setTimeout(this.setState({
                [name]: value
            }), 500);
        }
        else {
            this.setState({
                [name]: value
            });
        }
    }

    handleLocTextManualChange(event) {
        const target = event.target;
        const value = target.type == 'checkbox' ? target.checked : target.value;
        if (target.type == 'text') {
            if (value == "") {
                this.setState({
                    selectedLat: 0,
                    selectedLon: 0,
                    selectedAddress: '',
                    useCurLocation: false,
                    curLocationLat: 0,
                    curLocationLon: 0
                }, this.retrieveData);
            }
        }
    }

    async currentLocation() {
        this.props.ga_event('Landing Page', 'Current Location Clicked');

        if ("geolocation" in navigator) {
            await navigator.geolocation.getCurrentPosition(
                position => {
                    if (!position.coords.latitude || !position.coords.longitude || position.coords.latitude == 0 || position.coords.longitude == 0)
                    {
                        this.setState({
                            openValidation: true,
                            validationMessage: 'Your location could not be determined. Check if location services is enabled, or type your location instead.'
                        });
                    }
                    else {
                        this.setState({
                            useCurLocation: true,
                            curLocationLat: position.coords.latitude,
                            curLocationLon: position.coords.longitude
                        }, () => { document.getElementById('autocomplete').value = "Current Location" });
                    }
                },
                err => this.setState({
                    openValidation: true,
                    validationMessage: 'Your location could not be determined. Check if location services is enabled, or type your location instead.'
                })
            );
        }
        else
        {
            this.setState({
                openValidation: true,
                validationMessage: 'Your location could not be determined. Check if location services is enabled, or type your location instead.'
            });
        }
    }

    getClinics() {
        this.props.ga_event('Landing Page', 'Apply Search Button Clicked');

        var lat = this.state.useCurLocation ? this.state.curLocationLat : this.state.selectedLat;
        var lon = this.state.useCurLocation ? this.state.curLocationLon : this.state.selectedLon;
        var address = this.state.useCurLocation ? 'Current Location' : this.state.selectedAddress;
        window.location = this.state.base_url + "/ClinicSearch?Lat=" + lat + "&Lon=" + lon + "&Addr=" + address + "&SearchTerm=" + this.state.searchTerm;
    }

    render() {
        return (
            <Box className="fullHeightBoxMinusNav">
                <Container
                    maxWidth={false}
                    disableGutters={true}
                    className={"backgroundContainer hero_" + this.state.activeImgIdx}
                    style={{ height: "100%" }}
                    >
                    <Container maxWidth="xl" style={{ paddingTop: '.67em' }}>
                        <Box className="homeSearchContainer">
                            <Grid container
                                direction="row"
                                spacing={1}
                                justify="flex-start"
                                alignItems="center"
                                style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                                <Grid item xs={12} style={{ marginTop: "5%" }}>
                                    <Typography variant="h5" className="welcomeText">
                                        #StartWithSART
                                </Typography>
                                    <Typography variant="h1" className="welcomeTextLarge">
                                        Find an IVF Clinic
                                </Typography>
                                </Grid>

                                <Grid item sm={5} xs={12} className="homeInputContainer">
                                    <Input id="autocomplete"
                                        style={{ opacity: ".78" }}
                                        className="autocomplete topInput"
                                        ref="input"
                                        type="text"
                                        onChange={this.handleLocTextManualChange}
                                        placeholder="Enter location or use icon to the right"
                                        endAdornment={
                                            <Tooltip title="Use Current Location" arrow>
                                                <InputAdornment position="end">
                                                    <MyLocationIcon onClick={this.currentLocation} />
                                                </InputAdornment>
                                            </Tooltip>
                                        }
                                    />
                                </Grid>
                                <Grid item sm={5} xs={12} className="homeInputContainer">
                                    <Input id="searchTerm"
                                        style={{ opacity: ".78" }}
                                        name="searchTerm"
                                        className="autocomplete bottomInput"
                                        type="text"
                                        value={this.state.searchTerm}
                                        placeholder="Clinic name or keywords"
                                        onChange={this.handleFilterChanged}
                                    />
                                </Grid>
                                <Grid item sm={2} xs={12}>
                                    <Button variant="contained" color="primary" onClick={this.getClinics} style={{width:"100%", height:"48px"}}>Search</Button>
                                </Grid>
                            </Grid>
                        </Box>
                        
                        <Box className="standardsBox" boxShadow={3}>
                            <p className="memberClinics">Our member clinics meet the highest standards.</p>
                            <Button style={{ color: "#4C9462", fontWeight: "bold", textDecoration: "underline", textTransform:"none" }} className="learnMore" onClick={this.handleOpen}>Learn More</Button>
                        </Box>
                    </Container>
                </Container>
                <Modal
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <div className="modalStyle" >
                        <div className="modalBody">
                            <h2 className="infoHeader">#StartWithSART</h2>
                            <ul>
                                <li>SART clinics are committed to the highest quality standard of care.</li>
                                <li>All clinics are required to advertise truthfully.</li>
                                <li>All SART clinics accurately report outcomes so that you, the patient, can trust your provider.</li>
                                <li>All SART clinics work with nationally accredited laboratories to assure the best possible reproductive environments.</li>
                            </ul>
                        </div>
                        <hr />
                        <div className="modalFooter">
                            <Button style={{ float: "right", marginBottom:"10px" }} variant="contained" color="primary" onClick={this.handleClose}>Close</Button>
                        </div>
                    </div >
                </Modal>
                <Modal
                    open={this.state.openValidation}
                    onClose={this.handleCloseValidation}>
                    <div className="modalStyle" >
                        <div className="modalBody" style={{textAlign: "center"}}>
                            <h4 className="infoHeader">{this.state.validationMessage}</h4>
                        </div>
                        <hr />
                        <div className="modalFooter">
                            <Button style={{ float: "right", marginBottom: "10px" }} variant="contained" color="primary" onClick={this.handleCloseValidation}>Close</Button>
                        </div>
                    </div >
                </Modal>
            </Box>
        );
    }
}
 
export default Home;